import React from "react";
import { AutocompleteRenderOptionState } from "@mui/material";
import { SegmentView } from "@tiny/api";
import { Box, Checkbox, Grid, Typography } from "@tiny/components";
import { formatNumber } from "@tiny/components/src/utils/formatUtils";
import { BoxProps } from "@mui/material";

interface AudienceOptionProps {
  option: SegmentView;
  state: AutocompleteRenderOptionState;
}

function AudienceOption(props: AudienceOptionProps) {
  const { option, state } = props;

  return (
    <Grid container spacing={2}>
      <Grid item>
        <Checkbox checked={state.selected} readOnly color="primary" />
      </Grid>
      {option.segmentType && (
        <Grid item>
          {option.segmentType === "INTEGRATION" && (
            <Circle bgcolor="blue.light">I</Circle>
          )}
          {option.segmentType === "UPLOAD" && (
            <Circle bgcolor="purple.main">M</Circle>
          )}
        </Grid>
      )}
      <Grid item flex="1">
        <Box display="block" mt={0.5}>
          <Typography
            fontWeight={state.selected ? "bold" : undefined}
            variant="label1"
            color="grey"
            tone={800}
            wordBreak="break-all"
          >
            {option.name}
          </Typography>
        </Box>
      </Grid>
      <Grid item>
        <Box display="block" mt={0.5}>
          <Typography
            fontWeight={state.selected ? "bold" : undefined}
            variant="label1"
            color="grey"
            tone={800}
          >
            {formatNumber(option.numberOfCustomers)}
          </Typography>
          <Typography
            variant="label1"
            color="grey"
            tone={state.selected ? 800 : 600}
          >
            {" Customers"}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

function Circle(props: BoxProps) {
  return (
    <Box
      mt={1}
      textAlign="center"
      width={16}
      height={16}
      borderRadius="999px"
      color="common.white"
      fontSize={8}
      lineHeight="18px"
      fontWeight="bold"
      {...props}
    />
  );
}

export default AudienceOption;
